import { ChangeDetectorRef, Component, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';
import { PuzzleFrameworkService } from '../puzzle-framework.service';
import { PuzzleGameState } from '../../store/puzzle-game.state';
import { PuzzleGameTypesEnum } from '../puzzle-game-types.enum';
import { PuzzleGameModel } from '../../store/puzzle-game.model';

@Component({
  selector: 'lib-app-abstract-puzzle-board',
  templateUrl: './puzzle-board.component.html',
  styleUrls: ['./puzzle-board.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class PuzzleBoardComponent {
  public puzzleGame: PuzzleGameModel;
  private puzzleGameType: PuzzleGameTypesEnum;
  private puzzleId: string;

  private solutionWord: string;
  private solutionOriginal: string;

  private jokerCount = 0;

  constructor(
    protected store: Store,
    protected framework: PuzzleFrameworkService,
    @Optional() protected cdr: ChangeDetectorRef = null
  ) {}

  protected initPuzzleGame(
    puzzleID: string = this.puzzleId,
    GameType: PuzzleGameTypesEnum = this.puzzleGameType,
    jokerCount = 0,
    solutionWord?: string,
    solutionOriginal?: string
  ) {
    this.puzzleId = puzzleID;
    this.puzzleGameType = GameType;
    this.solutionWord = solutionWord;
    this.solutionOriginal = solutionOriginal;

    this.jokerCount = jokerCount;

    this.store.select(PuzzleGameState.getByID(puzzleID)).subscribe((puzzleGame) => {
      if (puzzleGame === null) {
        this.framework.initPuzzleGameState(puzzleID, GameType, jokerCount, solutionWord, solutionOriginal);
        return;
      }
      this.puzzleGame = puzzleGame as PuzzleGameModel;
      // OnPush subclasses need a manual CD nudge for external store updates
      this.cdr?.markForCheck();
    });
  }

  protected async resetPuzzleGame(
    puzzleID: string = this.puzzleId,
    GameType: PuzzleGameTypesEnum = this.puzzleGameType,
    jokerCount = this.jokerCount,
    solutionWord: string = this.solutionWord,
    solutionOriginal: string = this.solutionOriginal
  ) {
    const result = await this.framework.initPuzzleGameState(
      puzzleID,
      GameType,
      jokerCount,
      solutionWord,
      solutionOriginal
    );
    // Inform parent frame (postMessage integration) that the game was restarted
    // so it can drop its persisted gameData copy.
    this.framework.notifyParentResetGameData(puzzleID);
    return result;
  }
}
